/* ARQUITECTURA BASE DE UN REDUCER */
//export const defaultState = 0;

// export default (state = defaultState, { type, payload }) => {
//     switch (type) {
//         default:
//             return state;
//     }
// }

import { IPais, ITenant } from '../../pages/AbmLocalPage/types'

export const defaultTenant: ITenant = {
  idTenant: 1,
  idPais: 1,
  nombre: 'Avellaneda',
  nombrePlataforma: 'Avellaneda a un toque',
  path: 'avellaneda',
  latitud: 0,
  longitud: 0,
  radioMetros: 0,
  dominios: 'avellanedaauntoque.com',
  abreviatura: null,
  pais: {} as IPais,
  logo: '',
  config: []
}

export default (state = defaultTenant, action: any): ITenant => {
  switch (action.type) {
    case 'setTenant':
      return {
        idTenant: action.payload.idTenant,
        idPais: action.payload.idPais,
        nombre: action.payload.nombre,
        nombrePlataforma: action.payload.nombrePlataforma,
        path: action.payload.path,
        latitud: action.payload.latitud,
        longitud: action.payload.longitud,
        radioMetros: action.payload.radioMetros,
        dominios: action.payload.dominios,
        abreviatura: action.payload.abreviatura,
        pais: action.payload.pais,
        logo: action.payload.logo,
        config: action.payload.config
      }
    case 'clearTenant':
      return defaultTenant
    default:
      return state
  }
}
